// @ts-nocheck
import { getLabelPathFromLabelConfig } from '../utils/labels';
import { DEFAULT_ROUTE_CONFIG } from './defaultRoutesConfig';

/**
 * 1. key must be unique across Object and Nested Object.
 * 2. if you are changing template keys make to update those in
 *    transformPermissionJsonObject and extractPermissions function in groupPermissionUtils
 */
const MODULE_SUB_MODULE = {
  HM: {
    objKey: 'HM',
    label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.home.keyPath, 'label', 'Home')}`,
    key: 'Home',
    subModules: {
      HMRP: {
        objKey: 'HMRP',
        label: 'Resource Planning',
        key: 'resourcePlanning',
      },
      HMBC: {
        objKey: 'HMBC',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.report.keyPath, 'label', 'Reports')}`,
        key: 'homeReports',
      },
      HMN: {
        objKey: 'HMN',
        label: 'Landscape',
        key: 'homeNetwork',
      },
      RM: {
        objKey: 'RM',
        label: 'Examination review',
        key: 'regulatoryMapper',
      },
      TSK: {
        objKey: 'TSK',
        label: 'Tasks',
        key: 'Tasks',
        subModules: {
          OT: {
            objKey: 'OT',
            label: 'Open Tasks',
            key: 'openTasks',
          },
          STQ: {
            objKey: 'STQ',
            label: 'System Tasks Queue',
            key: 'systemTasksQueue',
          },
          DT: {
            objKey: 'DT',
            label: 'Delegated Tasks',
            key: 'delegatedTasks',
          },
        },
      },
    },
  },

  INV: {
    objKey: 'INV',
    label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.inventory.keyPath, 'label', 'Inventory')}`,
    key: 'Inventory',
    subModules: {},
  },
  DI: {
    objKey: 'DI',
    label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.documentInventory.keyPath, 'label', 'Documents')}`,
    key: 'DocumentInventory',
    subModules: {
      DI: {
        objKey: 'DI',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.documentInventory.keyPath, 'label', 'Documents')}`,
        key: 'documentInventory',
      },
    },
  },
  RR: {
    objKey: 'RR',
    label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.report.keyPath, 'label', 'Reports')}`,
    key: 'RulesReports',
    subModules: {
      RP: {
        objKey: 'RP',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.report.keyPath, 'label', 'Reports')}`,
        key: 'report',
      },
      ARP: {
        objKey: 'ARP',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.advanceReport.keyPath, 'label', 'AdvanceReport')}`,
        key: 'advanceReport',
      },
      ORP: {
        objKey: 'ORP',
        label: 'Other Query Permission',
        key: 'otherQuery',
      },
      OPR: {
        objKey: 'OPR',
        label: 'Create Category Permission',
        key: 'createCategory',
      },
      OMC: {
        objKey: 'OMC',
        label: 'Link to Category Permission',
        key: 'linkCategory',
      },
    },
  },
  RAD: {
    objKey: 'RAD',
    label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.reportsAndDashboards.keyPath, 'label', 'Reports & Dashboards')}`,
    key: 'ReportAndDashboard',
    subModules: {
      RADCR: {
        objKey: 'RADCR',
        label: 'Create report',
        key: 'createReport',
      },
      RADCD: {
        objKey: 'RADCD',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.createDashboard.keyPath, 'label', 'Create dashboard')}`,
        key: 'createDashboard',
      },
      RADED: {
        objKey: 'RADED',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.editDashboard.keyPath, 'label', 'Edit dashboard')}`,
        key: 'editDashboard',
      },
      RADVR: {
        objKey: 'RADVR',
        label: 'View report',
        key: 'viewReport',
      },
      RADVRH: {
        objKey: 'RADVRH',
        label: 'View report history',
        key: 'viewReportHistory',
      },
      RADVD: {
        objKey: 'RADVD',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.viewDashboard.keyPath, 'label', 'View dashboard')}`,
        key: 'viewDashboard',
      },
    },
  },
  BA: {
    objKey: 'BA',
    label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.bulkActions.keyPath, 'label', 'Bulk Actions')}`,
    key: 'BulkActions',
    subModules: {
      BU: {
        objKey: 'BU',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.bulkUpload.keyPath, 'label', 'Bulk upload')}`,
        key: 'bulkUpload',
      },
      BT: {
        objKey: 'BT',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.bulkTransition.keyPath, 'label', 'Bulk transition')}`,
        key: 'bulkTransition',
      },
      BUpdate: {
        objKey: 'BUpdate',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.bulkUpdate.keyPath, 'label', 'Bulk update')}`,
        key: 'bulkUpdate',
      },
    },
  },
  CNF: {
    objKey: 'CNF',
    label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.configuration.keyPath, 'label', 'Configuration')}`,
    key: 'Configuration',
    subModules: {
      WF: {
        objKey: 'WF',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.workflow.keyPath, 'label', 'Workflows')}`,
        key: 'workflow',
      },
      TL: {
        objKey: 'TL',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.templateList.keyPath, 'label', 'Templates')}`,
        key: 'templateList',
      },
      AL: {
        objKey: 'AL',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.attributeLibrary.keyPath, 'label', 'Attributes')}`,
        key: 'attributes',
      },
      CA: {
        objKey: 'CA',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.constantAttributes.keyPath, 'label', 'Constant Attributes')}`,
        key: 'constantAttributes',
      },
      TR: {
        objKey: 'TR',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.teamRoles.keyPath, 'label', 'Team Roles')}`,
        key: 'teamRoles',
      },
      DT: {
        objKey: 'DT',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.documentTemplate.keyPath, 'label', 'Document Template')}`,
        key: 'documentTemplate',
      },
      RU: {
        objKey: 'RU',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.rules.keyPath, 'label', 'Rules')}`,
        key: 'rules',
      },
      // DYT: {
      //   objKey: 'DYT',
      //   label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.dynamicToolbar.keyPath, 'label', 'Dynamic Toolbar')}`,
      //   key: 'dynamicToolbar',
      // },
      DC: {
        objKey: 'DC',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.dynamicChart.keyPath, 'label', 'Dynamic Chart')}`,
        key: 'dynamicChart',
      },
      TA: {
        objKey: 'TA',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.themeAndAppearance.keyPath, 'label', 'Theme and Appearance')}`,
        key: 'themeAndAppearance',
      },
      AUT: {
        objKey: 'AUT',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.automation.keyPath, 'label', 'Automation')}`,
        key: 'automation',
      },
      ET: {
        objKey: 'ET',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.emailTemplate.keyPath, 'label', 'Email Template')}`,
        key: 'emailTemplate',
      },
      DCG: {
        objKey: 'DCG',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.homepageSetup.keyPath, 'label', 'Homepage Setup')}`,
        key: 'homepageSetup',
      },
      EM: {
        objKey: 'EM',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.entityManagement.keyPath, 'label', 'Entity Management')}`,
        key: 'entityManagement',
      },
      SID: {
        objKey: 'SID',
        label: 'System ID',
        key: 'systemId',
      },
      IVT: {
        objKey: 'IVT',
        label: 'ID via Template',
        key: 'idViaTemplate',
      },
      ENT: {
        objKey: 'ENT',
        label: 'Entity Type',
        key: 'entityType',
      },
    },
  },
  AO: {
    objKey: 'AO',
    label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.administrativeOptions.keyPath, 'label', 'Administrative Options')}`,
    key: 'AdministrativeOptions',
    subModules: {
      UM: {
        objKey: 'UM',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.userManagement.keyPath, 'label', 'User management')}`,
        key: 'userManagement',
      },
      AM: {
        objKey: 'AM',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.appManagement.keyPath, 'label', 'App management')}`,
        key: 'appManagement',
      },
    },
  },
  LOG: {
    objKey: 'LOG',
    label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.logs.keyPath, 'label', 'Logs')}`,
    key: 'Logs',
    subModules: {
      CNFLOG: {
        objKey: 'CNFLOG',
        label: `${getLabelPathFromLabelConfig(DEFAULT_ROUTE_CONFIG.configurationLogs.keyPath, 'label', 'System Logs')}`,
        key: 'configurationLogs',
      },
    },
  },
};

/**
 * Generates module submodule entries for dynamic entities
 * Each dynamic entity gets the same access control structure as static entities (Use Case, etc.)
 * Structure: ROOT key for access, All tab, My tab, and Templates
 */
const buildDynamicModuleSubmodules = (entityTypes = []) => {
  if (!Array.isArray(entityTypes) || entityTypes.length === 0) {
    return {};
  }

  const seen = new Set();
  const dynamicModules = {};

  entityTypes
    .filter((entityType, index) => {
      const labelKey = String(entityType?.label ?? index)
        .trim()
        .replace(/\s+/g, ' ')
        .toLowerCase();
      if (seen.has(labelKey)) {
        return false;
      }
      seen.add(labelKey);
      return true;
    })
    .forEach((entityType, index) => {
      const entityLabel = entityType?.label || `Entity${index}`;
      // Generate unique keys: normalize label and create uppercase objKey
      const normalizedLabel = entityLabel
        .trim()
        .replace(/\s+/g, '')
        .toUpperCase();
      const objKey = `DYN_${normalizedLabel}`;
      const safeKey = entityLabel
        .toLowerCase()
        .replace(/\s+/g, '')
        .replace(/[^a-z0-9]/g, '');

      // Structure mirrors USE_CASE with ROOT, All, My, and Templates
      dynamicModules[objKey] = {
        objKey,
        label: entityLabel,
        key: safeKey,
        subModules: {
          [`${objKey}ROOT`]: {
            objKey: `${objKey}ROOT`,
            label: entityLabel,
            key: `${safeKey}Access`,
          },
          [`A${objKey}`]: {
            objKey: `A${objKey}`,
            label: `All ${entityLabel} Tab`,
            key: `all${normalizedLabel}`,
            permissionType: 'boolean',
          },
          [`M${objKey}`]: {
            objKey: `M${objKey}`,
            label: `My ${entityLabel} Tab`,
            key: `my${normalizedLabel}`,
            permissionType: 'boolean',
          },
          TMP: {
            objKey: 'TMP',
            label: 'Templates',
            key: `template`,
            subModules: {},
          },
        },
      };
    });

  return dynamicModules;
};

/**
 * Merges dynamic entity modules into the Inventory section
 * Maintains existing static modules while adding dynamic ones
 *
 * @param {Array} entityTypes - Array of entity type objects with label and value
 * @returns {Object} Complete MODULE_SUB_MODULE structure with dynamic entities integrated
 *
 * @example
 * const entityTypes = [
 *   { label: 'Product', value: 'product' },
 *   { label: 'Service', value: 'service' }
 * ];
 * const moduleConfig = buildModuleSubmoduleWithDynamics(entityTypes);
 * // Now Product and Service appear under Inventory with full access control:
 * // - INV.subModules.DYN_PRODUCT (with ROOTKEY, All tab, My tab, Templates)
 * // - INV.subModules.DYN_SERVICE (with ROOTKEY, All tab, My tab, Templates)
 */
const buildModuleSubmoduleWithDynamics = (
  entityTypes = [],
  frontendConfig = {}
) => {
  const dynamicModules = buildDynamicModuleSubmodules(entityTypes);
  const showReportAndDashboard =
    frontendConfig?.showReportAndDashboard === true;

  const baseModules = {
    ...MODULE_SUB_MODULE,
    INV: {
      ...MODULE_SUB_MODULE.INV,
      subModules: {
        ...MODULE_SUB_MODULE.INV.subModules,
        ...dynamicModules,
      },
    },
  };

  if (showReportAndDashboard) {
    const modulesWithoutReports = { ...baseModules };
    delete modulesWithoutReports.RR;
    return modulesWithoutReports;
  }

  const modulesWithoutReportAndDashboard = { ...baseModules };
  delete modulesWithoutReportAndDashboard.RAD;
  return modulesWithoutReportAndDashboard;
};

/**
 * Helper function to get the permission key for a dynamic entity and its access level
 * Follows the same pattern as static entities (e.g., 'Inventory_entityType')
 *
 * @param {string} entityLabel - The entity label/name
 * @returns {string} Permission key for the entity access level
 *
 * @example
 * getDynamicEntityPermissionKey('Product') // returns 'Inventory_product'
 * getDynamicEntityPermissionKey('My Entities') // returns 'Inventory_myentities'
 */
const getDynamicEntityPermissionKey = (entityLabel = '') => {
  const safeKey = String(entityLabel)
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/[^a-z0-9]/g, '');
  return `Inventory_${safeKey}`;
};

/**
 * Helper function to get the submodule permission key for a dynamic entity tab
 * Follows the same pattern as static entities (e.g., 'Inventory_entityType_allEntities')
 *
 * @param {string} entityLabel - The entity label/name
 * @param {string} tabType - Tab type: 'all', 'my', 'template'
 * @returns {string} Permission key for the specific tab
 *
 * @example
 * getDynamicEntityTabPermissionKey('Product', 'all') // returns 'Inventory_product_allproduct'
 * getDynamicEntityTabPermissionKey('Product', 'my') // returns 'Inventory_product_myproduct'
 * getDynamicEntityTabPermissionKey('Product', 'template') // returns 'Inventory_product_productTemplate'
 */
const getDynamicEntityTabPermissionKey = (
  entityLabel = '',
  tabType = 'all'
) => {
  const safeKey = String(entityLabel)
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/[^a-z0-9]/g, '');
  const normalizedLabel = String(entityLabel)
    .trim()
    .replace(/\s+/g, '')
    .toUpperCase();

  if (tabType === 'my') {
    return `Inventory_${safeKey}_my${normalizedLabel}`;
  }
  if (tabType === 'template') {
    return `Inventory_${safeKey}_template`;
  }
  // default to 'all'
  return `Inventory_${safeKey}_all${normalizedLabel}`;
};

const DYNAMIC_MODULE_SUBMODULE = {
  MI: {
    objKey: 'MI',
    label: `${getLabelPathFromLabelConfig('TEMPLATE_TYPES.ModelInventory', 'label', 'Models')}`,
    key: 'ModelInventory',
    subModules: {},
  },
  MA: {
    objKey: 'MA',
    label: `${getLabelPathFromLabelConfig('TEMPLATE_TYPES.ModelAssociation', 'label', 'Model Artifacts')}`,
    key: 'ModelAssociation',
    subModules: {},
  },
};

export default MODULE_SUB_MODULE;

export {
  DYNAMIC_MODULE_SUBMODULE,
  buildDynamicModuleSubmodules,
  buildModuleSubmoduleWithDynamics,
  getDynamicEntityPermissionKey,
  getDynamicEntityTabPermissionKey,
};
